const VIDEO_FILE_EXTENSIONS = /\.(mp4|webm|ogg|mov)(?:$|[?#])/i;

const normalizeUrl = (value) => {
  if (typeof value !== 'string' || !value.trim()) return null;

  try {
    return new URL(value.trim());
  } catch {
    return null;
  }
};

const getYouTubeVideoId = (url) => {
  const hostname = url.hostname.toLowerCase().replace(/^www\./, '');

  if (hostname === 'youtu.be') {
    return url.pathname.split('/').filter(Boolean)[0] || null;
  }

  if (hostname !== 'youtube.com' && hostname !== 'm.youtube.com' && hostname !== 'music.youtube.com') {
    return null;
  }

  if (url.pathname === '/watch') {
    return url.searchParams.get('v');
  }

  const [type, videoId] = url.pathname.split('/').filter(Boolean);
  return ['embed', 'shorts', 'live'].includes(type) ? videoId || null : null;
};

const getYouTubeStartTime = (url) => {
  const value = url.searchParams.get('start') || url.searchParams.get('t');
  if (!value) return null;
  if (/^\d+$/.test(value)) return value;

  const match = value.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/i);
  if (!match) return null;

  const seconds = (Number(match[1] || 0) * 3600)
    + (Number(match[2] || 0) * 60)
    + Number(match[3] || 0);
  return seconds > 0 ? String(seconds) : null;
};

export const getVideoSource = (value) => {
  const url = normalizeUrl(value);
  if (!url) return null;

  const youtubeId = getYouTubeVideoId(url);
  if (youtubeId) {
    const embedUrl = new URL(`https://www.youtube.com/embed/${encodeURIComponent(youtubeId)}`);
    const start = getYouTubeStartTime(url);
    if (start) embedUrl.searchParams.set('start', start);

    return { type: 'embed', url: embedUrl.toString() };
  }

  if (VIDEO_FILE_EXTENSIONS.test(url.pathname)) {
    return { type: 'file', url: url.toString() };
  }

  return null;
};
